import React, { useEffect, useState } from "react";
import { useCSS } from "../../lib/hooks";
import { i18nIntl, isNotEmpty } from "../../lib/ep";

import TimeCounterSimple from "../builder/TimeCounterSimple";
import LeveledHTMLText from "../front/helpers/LeveledHTMLText";
import ActionButton from "../builder/ActionButton";
import VideoEmbed from "../front/VideoEmbed";
import { injectIntl } from "react-intl";
import { VoteLoginPreview } from "../users/EntriesMultiGallery";
import { AlertMessage } from "../builder/Message";

export const AlertDisplayQR = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const display = props?.vars?.display_alert_dynamic_qr ?? false;
	
	if(!display) return null;

	return (
		<div class="flex_col col_1">
			<div class="register_media_flex">
				<AlertMessage
					icon={false}
					_class={{ other:'in_top' }}
				><p>{i18n("To validate the QR scan, you need to identify yourself within a maximum of 10 minutes.")}</p></AlertMessage>
			</div>
		</div>
	)
};

const LoginReminder = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.promotion ?? false;
	const participation = props?.participation ?? false;

	if(!promotion) return null;

	useCSS('comp/stages.css');

	const [is_expired, setIsExpired] = useState(false);
	
	const is_builder = props?.is_builder ?? false;
	const is_floating = props?.is_floating ?? false;
	const prize = participation?.PrizeType ?? false;
	const is_winner = participation?.prize ?? false;
	const extra_classes = props?.extra_classes ?? false;

	let classes = ['login_reminder', 'gui_main_text_color_on_bg'];
	if(extra_classes) classes.push(extra_classes);

	const toggleShow = (show) => {
		setTimeout(() => {
			const floating_item = document.getElementById('floating_login_reminder');

			if(floating_item != undefined) {
				(show) ? floating_item.classList.add('show') : floating_item.classList.remove('show');
			}
		}, 500);
	};

	useEffect(() => {
		if(is_winner && !is_floating) toggleShow(false);

		if(is_floating && document.getElementById('login_reminder') == undefined) {
			// Display the floating message if no item with id #login_reminder is already present in the DOM
			// (this is used to autohide - autoshow the floating message in the login & register pages,
			// where the claim warning is displayed inlined).
			//
			// TIP: to hide all the instances of the countdown + prize message (the floating and the inlined versions),
			// add the login_reminder item and pass the variable display_claim_resumee as false
			// (this way the code won't enter this if but won't display the claim info neither)
			toggleShow(true);
		}

		return () => {
			if(is_winner && !is_floating) toggleShow(true);
		}
	}, []);

	if(is_floating) {
		classes.push('is_floating');
		if(is_expired) classes.push('expired redBg');

		let classes_str = classes.join(" ");

		// We force the background to have full opacity,
		// so the message is readable in case of complex background images
		// or low opacity containers for the promotion layout.
		// So, we change the opacity class "_awt{XX}" (light) or "_abl{XX}" (dark)
		// from whatever value to a forced "100":
		const regexp = new RegExp("(_awt|_abl)([0-9]{1,3})");
		classes_str = classes_str.replace(regexp, "$1100");

		return (
			<aside id="floating_login_reminder" class={classes_str}>
				{(!is_expired) && (
					<>
						<TimeCounterSimple
							seconds={participation.remaining}
							hide_days={true}
							hide_hours={true}
							execute_countdown={!is_builder}
							inlined_label="Claim your prize in:"
							onFinish={() => {
								setIsExpired(true);
							}}
						/>

						<div class="login_button flex_button gui_not_in_top">
							<ActionButton
								_fullclass=""
								_href={`/login/${promotion.id}`}
							>Claim it!</ActionButton>
						</div>
					</>
				)}

				{(is_expired) && (
					<h3 class="whiteColor">{i18n("Oops! You lost your prize")}</h3>
				)}
			</aside>
		)
	}

	classes.push('flex_cols')

	let has_image_header;
	let has_video_header;
	let introduction_text;
	let one_step_login = promotion?.one_step_login ?? false;

	switch(parseInt(promotion.login_type)) {
		case 4:
			/*if(is_winner) {
				classes.push('is_winner');
				introduction_text = (isNotEmpty(promotion, 'play_first_winner')) ? promotion.play_first_winner : `<h1>${i18n("Congratulations!")}</h1><p>${i18n("You've won a prize! Register to claim it.")}</p>`;

				has_image_header = (promotion.full_login_image_prize != undefined && promotion.full_login_image_prize != "") ? promotion.full_login_image_prize : false;
				has_video_header = (!has_image_header && promotion.login_video_prize && promotion.login_video_prize.url) ? promotion.login_video_prize : false;
			} else {
				classes.push('is_loser');
				introduction_text = (isNotEmpty(promotion, 'play_first_loser')) ? promotion.play_first_loser : `<h1>${i18n("Identify yourself")}</h1><p>${i18n("Now it's time to register.")}</p>`;

				has_image_header = (promotion.full_login_image_loser != undefined && promotion.full_login_image_loser != "") ? promotion.full_login_image_loser : false;
				has_video_header = (!has_image_header && promotion.login_video_loser && promotion.login_video_loser.url) ? promotion.login_video_loser : false;
			}*/
			//break;
		
		default:
			const default_login_introduction = `<h1>${i18n("Identify yourself")}</h1><p>${i18n("Now it's time to register.")}</p>`;
			introduction_text = (isNotEmpty(promotion, 'login_introduction')) ? promotion.login_introduction : default_login_introduction;
			has_image_header = (isNotEmpty(promotion, 'full_login_image')) ? promotion.full_login_image : false;
			has_video_header = (!has_image_header && promotion.login_video && promotion.login_video.url) ? promotion.login_video : false;
			break;
	}

	const display_claim_resumee = props?.display_claim_resumee ?? true;

	if(!display_claim_resumee) {
		return (
			<aside id="login_reminder" class={classes.join(" ")}>
				<AlertDisplayQR
					vars={props?.vars ?? {}}
					intl={props.intl}
				/>

				<VoteLoginPreview
					candidate={props.vote_candidate}
					promotion={promotion}
					locale={props.locale}
					intl={props.intl}
				/>

				{props.children}
			</aside>
		)
	}

	return (
		<aside id="login_reminder" class={classes.join(" ")}>
			{(!one_step_login && (has_image_header || has_video_header)) && (
				<div class="flex_col col_1">
					<div class="register_media_flex">
						{(has_image_header !== false) && (
							<img src={has_image_header} style={{maxWidth:'100%'}} />
						)}

						{(has_video_header !== false) && (
							<VideoEmbed video_url={has_video_header.url} video_thumb={has_video_header.image} autoplay={false} />
						)}
					</div>
				</div>
			)}

			<div class="flex_col col_2">
				<AlertDisplayQR
					vars={props?.vars ?? {}}
					intl={props.intl}
				/>

				<VoteLoginPreview
					candidate={props.vote_candidate}
					promotion={promotion}
					locale={props.locale}
					intl={props.intl}
				/>

				<div class="register_form_flex" style={{width:'100%'}}>
					{(!one_step_login) && (
						<LeveledHTMLText>{introduction_text}</LeveledHTMLText>
					)}

					{props.children}

					{(is_winner) && (
						<div class="claim_resumee">
							<div class="resumee_item">
								<span class="label">{i18n("Your prize is")}:</span>
								<strong>{prize.title}</strong>
							</div>

							<div class="resumee_item">
								<span class="label">{i18n("Time left to claim the prize")}:</span>

								<TimeCounterSimple
									seconds={participation.remaining}
									hide_days={true}
									hide_hours={true}
									execute_countdown={!is_builder}
									onFinish={() => { }}
								/>
							</div>
						</div>
					)}
				</div>
			</div>
		</aside>
	)
};
export default injectIntl(LoginReminder);